import { LoaderSnackbarWrapperActions } from "@components/organisms/LoaderSnackbarWrapper/LoaderSnackbarWrapper.slice";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Collapse,
  IconButton,
  Slide,
  SlideProps,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { useEffect } from "react";
import { ConnectedProps, connect } from "react-redux";

type ReduxProps = ConnectedProps<typeof connector>;

type AlertProps = {
  isVisible: boolean;
  message: string;
  type: "error" | "success";
};

type TransitionProps = Omit<SlideProps, "direction">;

const TransitionDown = (props: TransitionProps) => {
  return <Slide {...props} direction="down" />;
};

const Alert = ({
  isVisible,
  message,
  type,
  setAlert,
}: AlertProps & ReduxProps) => {
  const alertTitle = type === "error" ? "Error" : "Success";

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setAlert({ alert: { isVisible: false } });
      }, 6000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isVisible, setAlert]);

  return (
    <>
      {type && isVisible && (
        <Box sx={{ width: "100%" }}>
          <Collapse in={isVisible}>
            <Snackbar
              open={isVisible}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              TransitionComponent={TransitionDown}
            >
              <MuiAlert
                sx={{ width: "100%" }}
                severity={type}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setAlert({
                        alert: {
                          isVisible: false,
                          message: message,
                          type: type,
                        },
                      });
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                <AlertTitle>{alertTitle}</AlertTitle>
                {message}
              </MuiAlert>
            </Snackbar>
          </Collapse>
        </Box>
      )}
    </>
  );
};

const mapDispatchToProps = {
  setAlert: LoaderSnackbarWrapperActions.setGlobalAppearances,
};

const connector = connect(undefined, mapDispatchToProps);
const AlertRedux = connector(Alert);

export { AlertRedux as Alert };
